// handle dark mode storage
window.darkMode = {
    get: function() {
        return localStorage.getItem('darkMode') == 'true';
    },
    set: function( active ) {
        localStorage.setItem('darkMode', active);
        this.updateDom();
    },
    updateDom: function() {
        document.querySelector('body').classList[ this.get() ? 'add' : 'remove']('dark');
    }
}
window.darkMode.updateDom();
